import { ActivityEntityType } from '../../api';

/**
 * Maps a polymorphic `ActivityEntityType` (used by both `ActivityEntry` and `Notification`) to
 * its feature's detail route.
 */
export const ENTITY_ROUTES: Partial<Record<ActivityEntityType, string>> = {
  [ActivityEntityType.Lead]: '/leads',
  [ActivityEntityType.Client]: '/clients',
  [ActivityEntityType.Quote]: '/quotes',
  [ActivityEntityType.Invoice]: '/invoices',
  [ActivityEntityType.Expense]: '/expenses',
};

/** Group headers for the global search results panel (task 10.5). */
export const ENTITY_LABELS: Partial<Record<ActivityEntityType, string>> = {
  [ActivityEntityType.Lead]: 'Leads',
  [ActivityEntityType.Client]: 'Clientes',
  [ActivityEntityType.Quote]: 'Presupuestos',
  [ActivityEntityType.Invoice]: 'Facturas',
};
